import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTwitchStyle0 = cosmosIconCss;

const CosmosIconTwitch$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTwitch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3c6855225ea40619d6919ee26226014f09b6358c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '83213de5b243c67133fb90dcab45569c666811cf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eabf7dc4005565aa9857775d53500b2bbc9547dc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 5.857 6.857 3h10.857v8l-5.143 5.143h-2.285L7.429 19v-2.857H4V5.857Zm10.286 6.857 2.285-2.285V4.143H7.43v8.571H10v2l2-2h2.286Zm-.572-6.571h1.143V9.57h-1.143V6.143Zm-2 0h-1.143V9.57h1.143V6.143Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTwitchStyle0; }
}, [1, "cosmos-icon-twitch", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-twitch"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-twitch":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTwitch$1);
            }
            break;
    } });
}

const CosmosIconTwitch = CosmosIconTwitch$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTwitch, defineCustomElement };
